import { render, staticRenderFns } from "./LawLibrary.vue?vue&type=template&id=73ac2261&"
import script from "./LawLibrary.vue?vue&type=script&lang=js&"
export * from "./LawLibrary.vue?vue&type=script&lang=js&"
import style0 from "./LawLibrary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports